export default __webpack_public_path__ + "static/media/Flameweave Sash.742a3848.jpg";